import React from 'react';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
const Howitworks = () =>{
   const [show, setShow] = useState(true);

   const handleClose = () => setShow(false);
   const handleShow = () => setShow(true);


  return(
<>
<section>
      <Modal show={show} onHide={handleClose} className='SubmitPopup'>
        <Modal.Header closeButton className='text-center'>
          <Modal.Title><h2 className="h2_medum fw-bold text-center" >How It<span className='color-9F7854 user-name fw-bold'> Works</span></h2></Modal.Title>
        </Modal.Header>
        <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
{/* <div className="container-fluid p-0 pt-5">
   <div className="row">
      <div className="col-lg-5">
        <Fixedbg/>
      </div>
      <div className="col-lg-6">
         <div className='row'>
            <div className="col">
               <h2 className="h2_medum" >How it<span className='color-9F7854 fw-bold'>works </span></h2>              
                <ul className='pt-3'>
                    <li className='pb-2'>At KBD, you can list a business or request a business listing. </li>
                    <li className='pb-2'>The first step is to sign up for the platform. </li>
                    <li className='pb-2'>The platform requires proof of identity from its members, which the admin verifies.</li>
                    <li className='pb-2'>For further verification, you are requested to add two community references. </li>
                    <li className='pb-2'>Once you are approved, you can now list a business and request a business listing in up to 3 categories. </li>
                    <li className='pb-2'>All requests, including signup, listing a business, and requesting a listing, are verified and approved by an admin. </li>
                </ul>
            </div>
         </div>
      </div>
   </div>
</div> */}
</section>
</>
  )}
export default Howitworks;